export default {
  'Normal routing': '普通路由',
  'Member center menu contents': '会员中心菜单目录',
  'Member center menu items': '会员中心菜单项',
  'English name': '英文名称',
  'Web side routing path': 'web端路由路径(path)'
}
